var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table-print",staticStyle:{"border":"solid 1px #333","border-collapse":"collapse"},attrs:{"border":"1"},domProps:{"innerHTML":_vm._s(_vm.printData)}})])}
var staticRenderFns = []

export { render, staticRenderFns }